<template>
  <div class="day-header-container">
    <span class="weekday-text">{{ desktopView ? weekdayText : weekdayText[0] }}</span>

    <div v-if="!!dayNumber" class="day-number-container" :class="isToday ? 'today' : ''">
      <span class="day-number-text">{{ dayNumber }}</span>
    </div>
  </div>
</template>

<script>
import './style.scss'

export default {
  name: "DayHeader",

  data() {
    return {
      windowWidth: window.innerWidth
    }
  },

  props: {
    dayNumber: String,
    isToday: {type: Boolean, required: true},
    weekdayText: {type: String, required: true}
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  computed: {
    desktopView() {
      return this.windowWidth >= 1024
    },
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },
  }
}
</script>
